// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { toBase64 } from '@aws-sdk/util-base64-browser';
export function bytes2JWK(rawKeyBytes) {
    // See https://tools.ietf.org/html/rfc7515#appendix-C Base64url Encoding
    const base64 = toBase64(rawKeyBytes);
    const base64Url = base64
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=/g, '');
    return {
        kty: 'oct',
        k: base64Url,
    };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYnl0ZXMyX2p3ay5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ieXRlczJfandrLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLG9FQUFvRTtBQUNwRSxzQ0FBc0M7QUFFdEMsT0FBTyxFQUFFLFFBQVEsRUFBRSxNQUFNLDhCQUE4QixDQUFBO0FBRXZELE1BQU0sVUFBVSxTQUFTLENBQUMsV0FBdUI7SUFDL0Msd0VBQXdFO0lBQ3hFLE1BQU0sTUFBTSxHQUFHLFFBQVEsQ0FBQyxXQUFXLENBQUMsQ0FBQTtJQUNwQyxNQUFNLFNBQVMsR0FBRyxNQUFNO1NBQ3JCLE9BQU8sQ0FBQyxLQUFLLEVBQUUsR0FBRyxDQUFDO1NBQ25CLE9BQU8sQ0FBQyxLQUFLLEVBQUUsR0FBRyxDQUFDO1NBQ25CLE9BQU8sQ0FBQyxJQUFJLEVBQUUsRUFBRSxDQUFDLENBQUE7SUFDcEIsT0FBTztRQUNMLEdBQUcsRUFBRSxLQUFLO1FBQ1YsQ0FBQyxFQUFFLFNBQVM7S0FDYixDQUFBO0FBQ0gsQ0FBQyJ9